/**
 * /advertisers/publisher-stats — advertiser publisher breakdown (FS-148).
 *
 * Declares the TanStack Router route and delegates rendering to
 * `AdvertiserPublisherStatsPage`. The flat-file naming convention uses dots
 * as path separators, so `advertisers.publisher-stats.tsx` maps to
 * `/advertisers/publisher-stats`.
 *
 * `validateSearch` reserves `?advertiserId=` so operators can deep-link from
 * an advertiser detail view with the id prefilled.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserPublisherStatsPage } from "@/features/advertiser-publisher-stats/AdvertiserPublisherStatsPage";

interface AdvertiserPublisherStatsSearch {
	advertiserId?: string;
}

export const advertisersPublisherStatsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/publisher-stats",
	validateSearch: (
		raw: Record<string, unknown>,
	): AdvertiserPublisherStatsSearch => {
		const advertiserId = raw.advertiserId;
		if (typeof advertiserId === "string" && advertiserId.trim().length > 0) {
			return { advertiserId: advertiserId.trim() };
		}
		return {};
	},
	component: AdvertiserPublisherStatsRouteComponent,
});

export default advertisersPublisherStatsRoute;

export function AdvertiserPublisherStatsRouteComponent() {
	const { advertiserId } = advertisersPublisherStatsRoute.useSearch();
	return (
		<AdvertiserPublisherStatsPage initialAdvertiserId={advertiserId} />
	);
}
